/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import {
  Autocomplete,
  AutocompleteRenderOptionState,
  Avatar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormHelperText,
  FormLabel,
  IconButton,
  LinearProgress,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Tooltip,
  Typography,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import classes from "../CreateTenant/CreateTenantPage.module.css";
import CloseIcon from "@mui/icons-material/Close";

import {
  editTenantDetails,
  getAvailableCurrencies,
  getAvailableDataCenters,
  getAvailableProducts,
  getGeoMapping,
  getTenantLogo,
  uploadTenantLogoDetails,
} from "../../store/Tenant/tenant-actions";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  CreateorEditTenantDto,
  GeoMapping,
  IErrorProps,
  MappingCountry,
  MappingRegion,
  MappingState,
  OptionsProduct,
  OptionsTimeZone,
} from "../../models";
import { AppDispatch, RootState } from "../../store";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import IFile from "../Image/types/File";
import editLogo from "../CreateTenant/EditLogo.png";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import updateErrorList from "../../utils/methods/updateErrorList";
import DialogForError from "../SharedComponents/DialogForError";
import ToastBarForError from "../SharedComponents/ToastBarForError";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function EditTenantPage() {
  const isInitialComponentRender = useRef(true);
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const backButtonHandler = () => {
    navigate("/tenant");
  };

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const [tenantNameDefaultValue, setTenantNameDefaultValue] =
    useState<string>("");
  const [orgNameDefaultValue, setOrgNameDefaultValue] = useState<string>("");
  const [headquarterAddressDefaultValue, setHeadquarterAddressDefaultValue] =
    useState<string>("");
  const [countryDefaultValue, setCountryDefaultValue] = useState<string>("");
  const [regionDefaultValue, setRegionDefaultValue] = useState<string>("");
  const [stateDefaultValue, setStateDefaultValue] = useState<number>(0);
  const [zipcodeDefaultValue, setZipcodeDefaultValue] = useState<string>("");
  const [currencyDefaultValue, setCurrencyDefaultValue] = useState<string>("");
  const [dataCenterDefaultValue, setDataCenterDefaultValue] =
    useState<string>("");
  const [timezoneDefaultValue, setTimezoneDefaultValue] = useState<string>("");
  const [productDefaultValueList, setProductDefaultValueList] = useState<
    string[]
  >([]);
  const [
    productsConcatenatedInAsDefaultValue,
    setProductsConcatenatedInAsDefaultValue,
  ] = useState("");
  const [isFormDataChanged, setIsFormDataChanged] = useState<boolean>(false);

  const [regionMapping, setRegionMapping] = useState<Array<MappingRegion>>([]);
  const [countryMapping, setCountryMapping] = useState<Array<MappingCountry>>(
    []
  );
  const [stateMapping, setStateMapping] = useState<Array<MappingState>>([]);
  const [TimezoneMapping, setTimezoneMapping] = useState<
    Array<OptionsTimeZone>
  >([]);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  // Error lists
  const [errorGeoMapping, seterrorGeoMapping] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [enteredTenantName, setTenantName] = useState("");
  const [enteredForgeId, setForgeId] = useState("");
  const [enteredheadquarterAddress, setheadquarterAddress] = useState("");
  const [enteredTimeZone, setTimeZone] = useState("");
  const [enteredDatacenter, setDataCenter] = useState("");
  const [enteredProduct, setProduct] = React.useState<OptionsProduct[]>([]);
  const [enteredProductSubmit, setProductSumbit] = React.useState<string[]>([]);
  const [tenanthasError, settenanthasError] = useState(false);
  const [OrgNamehasError, setOrgNamehasError] = useState(false);
  const [AddresshasError, setAddresshasError] = useState(false);
  const [enteredCurrency, setCurrency] = useState("");
  const [tenantID, setTenantID] = useState("");
  const [currentImage, setCurrentImage] = useState<File>();
  const [previewImage, setPreviewImage] = useState<string>("");
  const [progress, setProgress] = useState<number>(0);
  const [message, setMessage] = useState<string>("");
  const [imageInfos, setImageInfos] = useState<Array<IFile>>([]);
  const [tenantCurrentLogo, setCurrentTenantLogo] = useState<string>("");
  const [enteredCountry, setCountry] = useState("");
  const [enteredRegion, setRegion] = useState("");
  const [enteredState, setState] = useState("");

  const [enteredZipcode, setZipcode] = useState("");
  const [allSelected, setAllSelected] = useState(false);
  const [enteredOrgName, setOrgName] = useState("");
  const optionsGeoMapping: GeoMapping = useSelector(
    (state: RootState) => state.cart.geoMapping
  );
  const [errorAvailableDatacentre, seterrorAvailableDatacentre] = useState<
    Array<IErrorProps>
  >([]);
  const [errorAvailableTimezone, seterrorAvailableTimezone] = useState<
    Array<IErrorProps>
  >([]);
  const [errorAvailableCurrency, seterrorAvailableCurrency] = useState<
    Array<IErrorProps>
  >([]);
  const [errorAvailableProducts, seterrorAvailableProducts] = useState<
    Array<IErrorProps>
  >([]);
  const [errorAvailableCountries, seterrorAvailableCountries] = useState<
    Array<IErrorProps>
  >([]);
  const [errorAvailableRegion, seterrorAvailableRegion] = useState<
    Array<IErrorProps>
  >([]);
  const [errorEditCustomer, seterrorEditCustomer] = useState<
    Array<IErrorProps>
  >([]);
  const [errorLogo, seterrorLogo] = useState<Array<IErrorProps>>([]);
  const [updateerrorLogo, setupdateerrorLogo] = useState<Array<IErrorProps>>(
    []
  );
  const [isCountryDisabled, setIsCountryDisabled] = useState(false);
  const [isStateDisabled, setIsStateDisabled] = useState(
    +(location?.state?.editTenantDetails?.country as string) !== 1
  );

  const [isTimeZoneDisabled, setIsTimeZoneDisabled] = useState(false);

  const optionsDataCenter = useSelector(
    (state: RootState) => state.cart.availableDataCentres
  );
  let prodOptions: OptionsProduct[] = [
    { applicationId: "selectAll", applicationName: "Select All" },
  ];
  const optionsProduct = prodOptions.concat(
    useSelector((state: RootState) => state.cart.availableProducts)
  );
  const optionsProductFromStore = useSelector(
    (state: RootState) => state.cart.availableProducts
  );

  const optionsCurrency = useSelector(
    (state: RootState) => state.cart.availableCurrencies
  );
  // TODO: need to recalculate based on GeoMapping data

  const TenantNameRegex = /^[a-zA-Z\s]*$/; // Only allows alphanumeric characters
  const OrgNameRegex = /^[a-zA-Z0-9_\s\.\-]*$/; // Only allows alphanumeric characters
  const AddressRegex = /^[a-zA-Z0-9,\s\.\-]*$/; // Only allows alphanumeric charactersconst getCountryNameById = (countryId: string): string | undefined => {
  const isUpdated = useRef({
    tenantName: false,
    orgName: false,
    headquarterAddress: false,
    region: false,
    stateValue: false,
    country: false,
    zipcode: false,
    tenantDataCenter: false,
    products: false,
    currency: false,
    timezone: false,
    profilePic: false,
  });
  // istanbul ignore next
  // Get region By Id
  const getRegionById = (RegionId: string): string | undefined => {
    const region = regionMapping.find((c) => c.regionId === +RegionId);
    return region?.regionName;
  };

  // istanbul ignore next
  // Get country name By Id
  const getCountryNameById = (countryId: string): string | undefined => {
    const country = countryMapping.find((c) => c.countryId === +countryId);
    return country?.countryName;
  };

  //Get state By Id
  // istanbul ignore next
  const getStateById = (StateId: string): string | undefined => {
    const region = stateMapping.find((c) => c.stateId === +StateId);
    return region?.stateName;
  };

  // Get datcentre by Id
  // istanbul ignore next
  const getDataCenterById = (datacenterId: string): string | undefined => {
    const dataCenter = optionsDataCenter.find(
      (c) => c.datacenterId === datacenterId
    );
    return dataCenter?.datacenterName;
  };

  // Get currency By Id
  // istanbul ignore next
  const getCurrencyById = (currencyId: string): string | undefined => {
    const currency = optionsCurrency.find((c) => c.currencyId === currencyId);
    return currency?.currencyName;
  };

  // Get TimeZoneById
  // istanbul ignore next
  const getTimeZoneById = (timezoneId: string): string | undefined => {
    const timeZone = TimezoneMapping.find((c) => c.timezoneId === timezoneId);
    return timeZone?.timezoneName;
  };

  useEffect(() => {
    let x1 = optionsGeoMapping.countryDataMap.findIndex(
      (x) => x.country.countryId === +enteredCountry
    );
    let state: Array<MappingState> = [];

    if (x1 !== -1 && +enteredCountry === 1) {
      setIsStateDisabled(false);
      state = optionsGeoMapping.countryDataMap[x1].states;
      setStateMapping(state);
    } else {
      setIsStateDisabled(true);
    }
  }, [enteredCountry]);

  useEffect(() => {
    const newregionMapping: Array<MappingRegion> = [];
    optionsGeoMapping.regionDataMap.map((x) => {
      newregionMapping.push(x.region);
    });
    setRegionMapping(newregionMapping);
  }, [optionsGeoMapping]);

  useEffect(() => {
    let indexOfRegionData = optionsGeoMapping.regionDataMap.findIndex(
      (x) => x.region.regionId === +enteredRegion
    );
    let countries: Array<MappingCountry> = [];
    let timezone: Array<OptionsTimeZone> = [];
    // istanbul ignore next
    //for geomapping region finder
    if (indexOfRegionData !== -1) {
      countries = optionsGeoMapping.regionDataMap[indexOfRegionData].countries;
      timezone = optionsGeoMapping.regionDataMap[indexOfRegionData].timezones;

      setCountryMapping(countries);
      setTimezoneMapping(timezone);
    }
  }, [enteredRegion]);

  useEffect(() => {
    let x1 = optionsGeoMapping.countryDataMap.findIndex(
      (x) => x.country.countryId === +enteredCountry
    );
    let state: Array<MappingState> = [];
    // istanbul ignore next
    //for geomapping country finder
    if (x1 !== -1) {
      state = optionsGeoMapping.countryDataMap[x1].states;
      setStateMapping(state);
    }
  }, [enteredCountry]);

  // API calls
  // Get Datacentres if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableDataCenters())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorAvailableDatacentre(
            updateErrorList(error, [...errorAvailableDatacentre])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  // Get Geo mapping
  useEffect(() => {
    if (optionsGeoMapping.countryDataMap.length === 0) {
      setIsLoading(true);
      dispatch(getGeoMapping())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorGeoMapping(updateErrorList(error, [...errorGeoMapping]));
        })
        .finally(() => setIsLoading(false));
    }
  }, [optionsGeoMapping]);
  // Get currencies if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableCurrencies())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorAvailableCurrency(
            updateErrorList(error, [...errorAvailableCurrency])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);
  // Get available products if not present
  useEffect(() => {
    if (optionsProduct?.length === 1) {
      // 1 because Select All is optionally added by default
      setIsLoading(true);
      dispatch(getAvailableProducts())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorAvailableProducts(
            updateErrorList(error, [...errorAvailableProducts])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);
  useEffect(() => {
    const mergedErrors = [
      ...errorAvailableDatacentre,
      ...errorAvailableTimezone,
      ...errorAvailableCurrency,
      ...errorAvailableProducts,
      ...errorAvailableCountries,
      ...errorAvailableRegion,
      ...errorEditCustomer,
      ...errorLogo,
    ];
    if (
      mergedErrors.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }
    if (mergedErrors.some((x) => x.errorCode === 400) && !openToastError) {
      setOpenToastError(true);
    }
    if (
      mergedErrors.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
    setErrorList(mergedErrors);
  }, [
    errorAvailableCurrency,
    errorAvailableTimezone,
    errorAvailableDatacentre,
    errorAvailableProducts,
    errorAvailableCountries,
    errorAvailableRegion,
    errorEditCustomer,
    errorLogo,
    updateerrorLogo,
  ]);

  // istanbul ignore next
  //Update for button disabled
  const handleUpdateBtnDisable = (
    defaultValue: any,
    newValue: any,
    fieldModified:
      | "tenant"
      | "org"
      | "headqtrAdd"
      | "region"
      | "country"
      | "state"
      | "zipCode"
      | "datacenter"
      | "product"
      | "currency"
      | "timeZone"
  ) => {
    const valueUpdated = checkIfValueCHanged(
      defaultValue === undefined || defaultValue === null ? "" : defaultValue,

      newValue === undefined || newValue === null ? "" : newValue
    );
    switch (fieldModified) {
      case "tenant":
        isUpdated.current = { ...isUpdated.current, tenantName: valueUpdated };
        break;
      case "org":
        isUpdated.current = { ...isUpdated.current, orgName: valueUpdated };
        break;
      case "headqtrAdd":
        isUpdated.current = {
          ...isUpdated.current,
          headquarterAddress: valueUpdated,
        };
        break;
      case "region":
        isUpdated.current = { ...isUpdated.current, region: valueUpdated };
        break;
      case "country":
        isUpdated.current = { ...isUpdated.current, country: valueUpdated };
        if (newValue !== "1") {
          isUpdated.current = { ...isUpdated.current, stateValue: false };
        }
        break;
      case "state":
        isUpdated.current = { ...isUpdated.current, stateValue: valueUpdated };
        break;
      case "zipCode":
        isUpdated.current = { ...isUpdated.current, zipcode: valueUpdated };
        break;
      case "datacenter":
        isUpdated.current = {
          ...isUpdated.current,
          tenantDataCenter: valueUpdated,
        };
        break;
      case "product":
        isUpdated.current = { ...isUpdated.current, products: valueUpdated };
        break;
      case "currency":
        isUpdated.current = { ...isUpdated.current, currency: valueUpdated };
        break;
      case "timeZone":
        isUpdated.current = { ...isUpdated.current, timezone: valueUpdated };
        break;
      default:
        // Handle unknown field modification or provide a default case
        break;
    }
    const isAnyValueTrue = Object.values(isUpdated.current).some(
      (value) => value
    );

    if (isAnyValueTrue) {
      setIsFormDataChanged(true);
    } else {
      setIsFormDataChanged(false);
    }
  };

  useEffect(() => {
    if (isInitialComponentRender.current) {
      var currency = optionsCurrency?.filter(function (item) {
        return (
          item.currencyName == location?.state?.editTenantDetails?.currency
        );
      });

      var dataCenter = optionsDataCenter.filter(function (item) {
        return (
          item.datacenterName == location?.state?.editTenantDetails?.datacenter
        );
      });
      var timeZone = TimezoneMapping?.filter(function (item) {
        return (
          item.timezoneName == location?.state?.editTenantDetails?.timezone
        );
      });

      var country = countryMapping?.filter(function (item) {
        return item.countryName == location?.state?.editTenantDetails?.country;
      });

      var region = regionMapping?.filter(function (item) {
        return item.regionName == location?.state?.editTenantDetails?.region;
      });
      var state = stateMapping?.filter(function (item) {
        return item.stateName == location?.state?.editTenantDetails?.state;
      });

      var product = optionsProduct?.filter(function (productSelected) {
        return location?.state?.editTenantDetails?.products.some(
          (prod: { applicationId: string }) =>
            prod.applicationId === productSelected.applicationId
        );
      });

      setTenantName(location?.state?.editTenantDetails?.tenantName);
      setTenantNameDefaultValue(location?.state?.editTenantDetails?.tenantName);
      setheadquarterAddress(
        location?.state?.editTenantDetails?.headquarterAddress
      );
      setHeadquarterAddressDefaultValue(
        location?.state?.editTenantDetails?.headquarterAddress
      );
      setOrgNameDefaultValue(
        location?.state?.editTenantDetails?.organizationName
      );
      setOrgName(location?.state?.editTenantDetails?.organizationName);

      setTenantID(location?.state?.editTenantDetails?.id);
      setTenantNameDefaultValue(location?.state?.editTenantDetails?.tenantName);
      setForgeId(location?.state?.editTenantDetails?.forgeCustomerId);
      setZipcode(
        location?.state?.editTenantDetails?.zipcode === 0
          ? ""
          : location?.state?.editTenantDetails?.zipcode
      );
      setZipcodeDefaultValue(
        location?.state?.editTenantDetails?.zipcode === 0
          ? ""
          : location?.state?.editTenantDetails?.zipcode
      );

      setTenantID((params as any).id);
      // istanbul ignore next
      if (country.length > 0) {
        setCountry(country[0].countryId.toString());
        setCountryDefaultValue(country[0].countryId.toString());
        if (
          country[0].countryId.toString() === "1" &&
          stateMapping.length > 0
        ) {
          setState(state[0]?.stateId.toString());
          setStateDefaultValue(state[0]?.stateId);
        }
      }
      // istanbul ignore next
      //for geomapping region
      if (region?.length > 0) {
        setRegion(region[0].regionId as unknown as string);
        setRegionDefaultValue(region[0].regionId as unknown as string);
      }
      // istanbul ignore next
      //for  datatcenter setup
      if (dataCenter?.length > 0) {
        setDataCenter(dataCenter[0].datacenterId);
        setDataCenterDefaultValue(dataCenter[0].datacenterId);
      }
      // istanbul ignore next
      //for   setup timezone
      if (timeZone?.length > 0) {
        setTimeZone(timeZone[0].timezoneId);
        setTimezoneDefaultValue(timeZone[0].timezoneId);
      }
      // istanbul ignore next
      //for  currency setup
      if (currency?.length > 0) {
        setCurrency(currency[0].currencyId);
        setCurrencyDefaultValue(currency[0].currencyId.toString());
      }
      // Option Product by default has " Select All" value.
      // So, we need to check if its more than 1.For others its more than 0
      // istanbul ignore next
      if (
        product !== null &&
        product !== undefined &&
        optionsProductFromStore?.length > 0
      ) {
        setProduct(product);
        setProductDefaultValueList(
          product.map((productDef) => productDef.applicationId)
        );
        setProductsConcatenatedInAsDefaultValue(
          product
            .map((x) => x.applicationId)
            .sort()
            .join("_")
        );
      }
    }
  }, [
    optionsDataCenter,

    optionsCurrency,
    optionsProductFromStore,
    countryMapping,
    regionMapping,
    TimezoneMapping,
    stateMapping,
  ]);

  useEffect(() => {
    if (tenantID === "") {
    } else {
      setIsLoading(true);
      dispatch(getTenantLogo(tenantID))
        .unwrap()
        .then((response: any) => {
          setCurrentTenantLogo(response as string);
        })
        .catch((err) => seterrorLogo(updateErrorList(err, [...errorLogo])))
        .finally(() => setIsLoading(false));
    }
  }, [tenantID]);

  useEffect(() => {
    setProductSumbit(
      optionsProduct
        .filter(function (n) {
          return enteredProduct.indexOf(n) !== -1;
        })
        .map((x) => x.applicationId)
    );
  }, [enteredProduct]);

  const [errors, setErrors] = useState({
    custName: "",
    address1: "",
    timezone: "",
    datacenter: "",
    currency: "",
    // applications: "",
    forgeId: "",
    country: "",
    region: "",
    state: "",
  });

  const params = useParams();

  const TenantNameChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setTenantName(event.target.value);
    if (TenantNameRegex.test(event.target.value)) {
      settenanthasError(false);
    } else {
      settenanthasError(true);
    }
    handleUpdateBtnDisable(
      tenantNameDefaultValue,
      event.target.value.toString(),
      "tenant"
    );
  };

  // istanbul ignore next
  const ForgeIdChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setForgeId(event.target.value);
  };

  // istanbul ignore next
  const headquarterAddressChangeHandler = (event: any) => {
    setheadquarterAddress(event.target.value);
    if (AddressRegex.test(event.target.value)) {
      setAddresshasError(false);
    } else {
      setAddresshasError(true);
    }
    handleUpdateBtnDisable(
      headquarterAddressDefaultValue,
      event.target.value.toString(),
      "headqtrAdd"
    );
  };

  // istanbul ignore next
  const DataCenterChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setDataCenter(event.target.value);

    handleUpdateBtnDisable(
      dataCenterDefaultValue.toString(),
      event.target.value.toString(),
      "datacenter"
    );
  };

  // istanbul ignore next
  const CurrencyChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setCurrency(event.target.value);
    handleUpdateBtnDisable(
      currencyDefaultValue,
      event.target.value.toString(),
      "currency"
    );
  };

  // istanbul ignore next
  const TimezoneChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setTimeZone(event.target.value);
    handleUpdateBtnDisable(
      timezoneDefaultValue,
      event.target.value.toString(),
      "timeZone"
    );
  };

  // istanbul ignore next
  const CountryChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setCountry(event.target.value);
    handleUpdateBtnDisable(
      countryDefaultValue,
      event.target.value.toString(),
      "country"
    );
  };

  // istanbul ignore next
  const RegionChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setRegion(event.target.value);
    // Enable country field after selecting "Region" field
    setIsCountryDisabled(false);
    setIsTimeZoneDisabled(false);
    setCountry("");
    setTimeZone("");
    setState("");
    handleUpdateBtnDisable(
      regionDefaultValue.toString(),
      event.target.value.toString(),
      "region"
    );
    if (
      event.target.value.toString() !==
      location?.state?.editTenantDetails?.region
    ) {
      setIsFormDataChanged(true);
    }
  };

  // istanbul ignore next
  const StateChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setState(event.target.value);
    handleUpdateBtnDisable(
      stateDefaultValue.toString(),
      event.target.value.toString(),
      "state"
    );
  };

  // istanbul ignore next
  const ZipcodeChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequent renders
    setZipcode(event.target.value);
    handleUpdateBtnDisable(
      zipcodeDefaultValue,
      event.target.value.toString(),
      "zipCode"
    );
  };

  // istanbul ignore next
  const OrgNameChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    handleUpdateBtnDisable(
      orgNameDefaultValue,
      event.target.value.toString(),
      "org"
    );
    setOrgName(event.target.value);

    if (OrgNameRegex.test(event.target.value)) {
      setOrgNamehasError(false);
    } else {
      setOrgNamehasError(true);
    }
  };

  // Handle application selection
  // istanbul ignore next

  const handleApplicationSelection = (
    event: React.ChangeEvent<{}>,
    selectedOptions: OptionsProduct[]
  ) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    let selectedOptionValues: string[] = [];
    if (selectedOptions.find((option) => option.applicationId == "selectAll")) {
      if (selectedOptions.length == optionsProduct.length) {
        setProduct([]);
        setAllSelected(false);
      } else {
        setProduct(optionsProduct.slice(1));
        setAllSelected(true);
      }
    } else {
      if (selectedOptions.length == optionsProduct.length - 1) {
        setAllSelected(true);
      } else {
        setAllSelected(false);
      }
      setProduct(selectedOptions);
      /**To disable update button incase of no change in products selection */

      if (selectedOptions && selectedOptions.length > 0) {
        selectedOptionValues = selectedOptions.map(
          (option) => option.applicationId
        );
      }
    }
    //#region Create newProductsConcatenatedValues
    let newProductsConcatenatedValues = selectedOptionValues.sort().join("_");
    if (
      selectedOptions.length >= 0 &&
      selectedOptions.map((x) => x.applicationId).some((y) => y == "selectAll")
    ) {
      newProductsConcatenatedValues = optionsProduct
        .filter((x) => x.applicationId !== "selectAll")
        .map((y) => y.applicationId)
        .sort()
        .join("_");
      // Make select All to applicationId concatenanted string
    }
    //#endregion

    handleUpdateBtnDisable(
      productsConcatenatedInAsDefaultValue,
      newProductsConcatenatedValues,
      "product"
    );
  };

  const commonStyles = {
    bgcolor: "background.paper",
    borderColor: "text.primary",
    m: 1,
    border: 1,
    width: "10rem",
    height: "10rem",
  };

  // istanbul ignore next
  // Check if the fields are filled
  // with input text
  const checkIfAnyTextFilled = () => {
    if (
      enteredTenantName === "" &&
      enteredheadquarterAddress === "" &&
      enteredCurrency === "" &&
      enteredDatacenter === "" &&
      // enteredProduct === []  &&
      enteredTimeZone === "" &&
      enteredForgeId === "" &&
      enteredCountry === "" &&
      enteredRegion === ""
    )
      return true;
    else return false;
  };

  // istanbul ignore next
  // Handle submit
  function onSubmitHandeller(event: any) {
    event.preventDefault();
    setCreateOpen(false);
    if (
      !validate() ||
      enteredProductSubmit.length === 0 ||
      AddresshasError ||
      tenanthasError ||
      OrgNamehasError
    )
      return;
    const tenantToEdit: CreateorEditTenantDto = {
      tenantName: enteredTenantName,
      headquarterAddress: enteredheadquarterAddress,
      timezone: enteredTimeZone,
      datacenter: enteredDatacenter as unknown as number,
      currency: enteredCurrency as unknown as number,
      applications: enteredProductSubmit,
      forgeCustomerId: enteredForgeId,
      country: enteredCountry as unknown as number,
      region: enteredRegion as unknown as number,
    };
    let tenantId = location?.state?.editTenantDetails?.id;
    let zipCodeOfTenant = enteredZipcode as unknown as number;

    // Add zipCode if valid value is present
    if (zipCodeOfTenant > 0) {
      tenantToEdit.zipcode = zipCodeOfTenant;
    }

    // Add organization Name if its not empty string which is set by default
    if (enteredOrgName !== "") {
      tenantToEdit.organizationName = enteredOrgName;
    }
    if (+enteredCountry === 1) {
      tenantToEdit.state = +enteredState;
    }
    const postData = { ...tenantToEdit, id: tenantId };
    if (previewImage === "") {
      setIsLoading(true);
      dispatch(editTenantDetails(postData))
        .unwrap()
        //// Earlier code will be as it is
        .then(() => navigate("/tenant"))
        .catch((err) =>
          seterrorEditCustomer(updateErrorList(err, [...errorEditCustomer]))
        )
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(true);
      dispatch(editTenantDetails(postData))
        .unwrap()

        .then(() => {
          const parameters1: any = {
            tenantId: tenantID,
            fileName: currentImage,
            progressBar: null,
          };
          dispatch(uploadTenantLogoDetails(parameters1))
            .unwrap()
            .then(() => {
              //
              navigate("/tenant");
            })
            .catch((err) => {
              setupdateerrorLogo(updateErrorList(err, [...updateerrorLogo]));
            });
        })
        .catch((err) => {
          seterrorEditCustomer(updateErrorList(err, [...errorEditCustomer]));
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  // istanbul ignore next
  // Handle validate
  const validate = () => {
    let temp = {
      custName: enteredTenantName,
      address1: enteredheadquarterAddress,
      timezone: enteredTimeZone,
      datacenter: enteredDatacenter,
      currency: enteredCurrency,
      forgeId: enteredForgeId,
      country: enteredCountry,
      region: enteredRegion,
      state: enteredState,
    };
    temp.custName = enteredTenantName ? "" : "This field is required";
    temp.forgeId = enteredForgeId ? "" : "This field is required";
    temp.address1 = enteredheadquarterAddress ? "" : "This field is required";
    temp.currency = enteredCurrency ? "" : "This field is required";
    temp.datacenter = enteredDatacenter ? "" : "This field is required";
    temp.timezone = enteredTimeZone ? "" : "This field is required";
    temp.country = enteredCountry ? "" : "This field is required";
    temp.region = enteredRegion ? "" : "This field is required";
    temp.state =
      isStateDisabled || enteredState ? "" : "This field is required";
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };
  // istanbul ignore next
  // to validate regex exp for input fields
  const validateData = () => {
    if (
      !validate() ||
      enteredProductSubmit.length === 0 ||
      AddresshasError ||
      tenanthasError ||
      OrgNamehasError
    )
      return;
    else {
      setCreateOpen(true);
    }
  };

  const confirmCancelHandller = () => {
    setCancelOpen(false);
    navigate("/tenant");
  };

  // istanbul ignore next
  //while updating image
  const ImageUpload: React.FC = () => {
    const selectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFiles = event.target.files as FileList;
      setCurrentImage(selectedFiles?.[0]);
      setPreviewImage(URL.createObjectURL(selectedFiles?.[0]));
      setProgress(0);
      // If image is updated , enable Update button
      isUpdated.current = { ...isUpdated.current, profilePic: true };
      setIsFormDataChanged(true);
    };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          marginLeft: "-4vh",
          zIndex: 1,
        }}
      >
        <IconButton
          sx={{
            backgroundColor: "#101010",
            color: "white",
            height: "4vh",
            width: "4vh",
            borderBlockColor: "black",
            borderTop: "1vh",
            position: "relative",
            bottom: "0px",
          }}
          onClick={handleIconClick}
          data-testid="imageEdit"
        >
          <EditIcon fontSize="small" sx={{ fontSize: "1rem" }} />
        </IconButton>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={selectImage}
          style={{ display: "none" }}
        />
        {currentImage && progress > 0 && (
          <div className="progress my-3">
            <div
              className="progress-bar progress-bar-info"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin={0}
              aria-valuemax={100}
              style={{ width: progress + "%", color: "red" }}
            >
              {progress}%
              <LinearProgress variant="determinate" value={progress} />
            </div>
          </div>
        )}
        {message && (
          <div className="alert alert-secondary mt-3" role="alert">
            {message}
          </div>
        )}
        {imageInfos.length > 0 && (
          <div className="card mt-3">
            <div className="card-header">List of Images</div>
            <ul className="list-group list-group-flush">
              {imageInfos.map((img, index) => (
                <li className="list-group-item" key={index}>
                  <p>
                    <a href={img.url}>{img.name}</a>
                  </p>
                  <img src={img.url} alt={img.name} height="80px" />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };
  const onDialogForServerCloseHandler = () => setOpenDialogServerError(false);
  const onDialogForNOURLCloseHandler = () => setOpenDialogNoURLError(false);
  // istanbul ignore next
  // to handle ToastBar Close
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={onSubmitHandeller}>
        <Grid
          container
          direction="row"
          p={1}
          sx={{ width: "100%", height: "auto" }}
        >
          <Grid
            item
            xs={12}
            sx={{ paddingBottom: 1, display: "flex", flexDirection: "row" }}
          >
            <Button
              onClick={backButtonHandler}
              sx={{
                padding: "0vh 0vh 0.7vh 0vh",
                fontSize: "1.1 rem",
                color: "#F0F0F0",
                justifyContent: "start",
                minWidth: "1vw",
                minHeight: "0.5vh",
              }}
              data-testid="arrow-back-icon"
            >
              <ArrowBackIosIcon sx={{ fontSize: "0.9 rem" }} />
            </Button>
            <Typography className={classes.mainheading}>
              Edit Tenant{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ height: "auto" }}>
            <Grid
              container
              direction="row"
              sx={{ width: "100%", height: "auto" }}
            >
              <Grid item p={2} className={classes.profileGrid}>
                <Typography className={classes.secondaryHeading}>
                  PROFILE INFORMATION
                </Typography>
                <Grid sx={{ marginBottom: "2vh" }}>
                  <Box
                    className={classes.AvatarBox}
                    sx={{
                      ...commonStyles,
                      backgroundImage: `url(${editLogo})`,
                    }}
                  >
                    {previewImage !== "" ? (
                      <Avatar
                        data-testid="avatar"
                        className={classes.editImage}
                        alt="Upload Logo"
                        src={previewImage}
                      />
                    ) : tenantCurrentLogo === "" ? (
                      <Avatar
                        data-testid="avatar"
                        className={classes.editImage}
                        alt="Upload Logo"
                        src={editLogo}
                      />
                    ) : (
                      <Avatar
                        className={classes.editImage}
                        alt="Upload Logo"
                        src={`data:image/jpeg;base64,${tenantCurrentLogo}`}
                      />
                    )}
                    <ImageUpload />
                  </Box>
                </Grid>
                <Box p={2} className={classes.setBoxTextFields}>
                  <FormLabel className={classes.label}>
                    Tenant Name <div style={{ color: "red" }}> *</div>
                  </FormLabel>
                  <TextField
                    fullWidth
                    data-testid="Tenant_Name"
                    id="Tenant_Name"
                    type="text"
                    size="small"
                    value={enteredTenantName}
                    onChange={TenantNameChangeHandler}
                    placeholder="Enter"
                    className={classes.textField}
                    inputProps={{
                      maxLength: 32,
                      "data-testid": "Tenant_Name_test",
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        marginTop: 0.4,
                        lineHeight: 0.9,
                      },
                    }}
                    {...((errors.custName !== "" || tenanthasError) && {
                      error: true,
                      helperText: tenanthasError
                        ? "Tenant name can only contain alphabets"
                        : "This is a required field",
                    })}
                  />
                </Box>
                <Box p={2} className={classes.setBoxTextFields}>
                  <FormLabel className={classes.label}>
                    Organization Name
                  </FormLabel>
                  <TextField
                    fullWidth
                    id="Org_Name"
                    data-testid="Org_Name"
                    type="text"
                    size="small"
                    sx={{
                      "& .MuiFormHelperText-root": {
                        marginTop: 0.4,
                        lineHeight: 0.9,
                      },
                    }}
                    value={enteredOrgName}
                    onChange={OrgNameChangeHandler}
                    className={classes.textField}
                    placeholder="Enter"
                    inputProps={{
                      maxLength: 32,
                      "data-testid": "Org_Name_test",
                    }}
                    {...(OrgNamehasError && {
                      error: true,
                      helperText:
                        "Organization name can only contain alphabets, dots(.) and hyphens(-) ",
                    })}
                  />
                </Box>
                <Box p={2} className={classes.setBoxTextFields}>
                  <FormLabel className={classes.label}>
                    Headquarter Address<div style={{ color: "red" }}> *</div>
                  </FormLabel>
                  <TextField
                    fullWidth
                    data-testid="HeadquarterAddress"
                    id="headquarterAddress"
                    type="text"
                    size="small"
                    sx={{
                      "& .MuiFormHelperText-root": {
                        marginTop: 0.4,
                        lineHeight: 0.9,
                        marginRight: 0,
                      },
                    }}
                    inputProps={{
                      maxLength: 32,
                      "data-testid": "Address_test",
                    }}
                    value={enteredheadquarterAddress}
                    onChange={headquarterAddressChangeHandler}
                    className={classes.textField}
                    placeholder="Enter"
                    {...((errors.address1 !== "" || AddresshasError) && {
                      error: true,
                      helperText: AddresshasError
                        ? "Address can only contain letters, numbers, dots(.) hyphens(-) & comma(,)"
                        : "This is a required field",
                    })}
                  />
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={6} md={6}>
                    <Box
                      className={classes.setBoxTextFieldsNew}
                      sx={{ lineHeight: 0 }}
                    >
                      <FormLabel className={classes.label}>
                        Region <div style={{ color: "red" }}> *</div>
                      </FormLabel>
                      <Select
                        data-testid="selectedRegion"
                        fullWidth
                        labelId="region"
                        id="region"
                        value={enteredRegion}
                        size="small"
                        type="text"
                        onChange={RegionChangeHandler}
                        className={classes.dropdown}
                        {...(errors.region !== "" && {
                          error: true,
                        })}
                        displayEmpty
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return (
                              <em className={classes.placeholder}>
                                Select Region
                              </em>
                            );
                          }

                          return getRegionById(selected);
                        }}
                      >
                        {regionMapping.map((optionsRegion) => (
                          <MenuItem
                            key={optionsRegion.regionId}
                            className={classes.dropdownNew}
                            value={optionsRegion.regionId}
                          >
                            {optionsRegion.regionName}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.region !== "" && (
                        <FormHelperText className={classes.requiredText}>
                          This is a required field
                        </FormHelperText>
                      )}
                    </Box>{" "}
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Box
                      className={classes.setBoxTextFieldsNew}
                      sx={{ lineHeight: 0 }}
                    >
                      <FormLabel className={classes.label}>
                        Country <div style={{ color: "red" }}> *</div>
                      </FormLabel>
                      <Tooltip
                        title={
                          isCountryDisabled
                            ? "Please select a region first"
                            : ""
                        }
                      >
                        <Select
                          fullWidth
                          data-testid="countryName"
                          labelId="countryName"
                          id="countryName"
                          value={enteredCountry}
                          size="small"
                          type="text"
                          onChange={CountryChangeHandler}
                          className={classes.dropdown}
                          {...(errors.country !== "" && {
                            error: true,
                          })}
                          displayEmpty
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <em className={classes.placeholder}>
                                  Select Country
                                </em>
                              );
                            }

                            return getCountryNameById(selected);
                          }}
                        >
                          {countryMapping.map((optionsCountry) => (
                            <MenuItem
                              key={optionsCountry.countryId}
                              className={classes.dropdown}
                              value={optionsCountry.countryId}
                            >
                              {optionsCountry.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </Tooltip>

                      {errors.country !== "" && (
                        <FormHelperText className={classes.requiredText}>
                          This is a required field
                        </FormHelperText>
                      )}
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  {+enteredCountry === 1 && (
                    <Grid item xs={6} md={6}>
                      <Box
                        className={classes.setBoxTextFieldsNew}
                        sx={{ lineHeight: 0 }}
                      >
                        <FormLabel className={classes.label}>
                          State <div style={{ color: "red" }}> *</div>
                        </FormLabel>
                        <Select
                          data-testid="selectedState"
                          fullWidth
                          labelId="state"
                          id="state"
                          value={enteredState}
                          size="small"
                          type="text"
                          onChange={StateChangeHandler}
                          className={classes.dropdown}
                          {...(errors.state !== "" && {
                            error: true,
                          })}
                          displayEmpty
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <em className={classes.placeholder}>
                                  Select State
                                </em>
                              );
                            }

                            return getStateById(selected);
                          }}
                        >
                          {stateMapping.map((optionsState) => (
                            <MenuItem
                              key={optionsState.stateId}
                              className={classes.dropdownNew}
                              value={optionsState.stateId}
                            >
                              {optionsState.stateName}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.state !== "" && (
                          <FormHelperText className={classes.requiredText}>
                            This is a required field
                          </FormHelperText>
                        )}
                      </Box>{" "}
                    </Grid>
                  )}
                  <Grid item xs={6} md={6} sx={{ margin: "0vh" }}>
                    <Box className={classes.setBoxTextFieldsNew}>
                      <FormLabel className={classes.label}>Zipcode</FormLabel>
                      <TextField
                        fullWidth
                        data-testid="selectZipcode"
                        id="zipcode"
                        type="text"
                        size="small"
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          maxLength: 6,
                        }}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);

                          // Allow only numbers (0-9)
                          if (!/^[0-9]+$/.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                        value={enteredZipcode}
                        onChange={ZipcodeChangeHandler}
                        className={classes.textField}
                        placeholder={enteredZipcode === null ? "" : "Enter"}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                p={2}
                sx={{
                  width: "65.34%",
                  background: "#272727",
                  border: "1px solid #101010",
                  boxShadow:
                    "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
                  borderRadius: ".7vw",
                  height: "77vh",
                  minheight: "550px",
                }}
              >
                <Typography className={classes.secondaryHeading}>
                  Other Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Box className={classes.setBoxTextFieldsOther}>
                      <FormLabel className={classes.label}>
                        Forge Customer ID<div style={{ color: "red" }}> *</div>
                      </FormLabel>

                      <TextField
                        data-testid="forgeTenantId"
                        disabled
                        placeholder="Enter"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            marginTop: 0.4,
                            lineHeight: 0.9,
                          },
                          "& .MuiInputBase-input": {
                            WebkitTextFillColor: "white",
                            color: "white",
                          },
                        }}
                        fullWidth
                        id="forge_TenantId"
                        type="text"
                        size="small"
                        value={enteredForgeId}
                        onChange={ForgeIdChangeHandler}
                        className={classes.uneditableField}
                        {...(errors.forgeId !== "" && {
                          error: true,
                          helperText: "This is a required field",
                        })}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box
                      className={classes.setBoxTextFieldsOther}
                      sx={{ lineHeight: 0 }}
                    >
                      <FormLabel className={classes.label}>
                        Tenant Currency <div style={{ color: "red" }}> *</div>
                      </FormLabel>
                      <Select
                        fullWidth
                        data-testid="selectCurrency"
                        labelId="currency"
                        id="currency"
                        value={enteredCurrency}
                        size="small"
                        type="text"
                        onChange={CurrencyChangeHandler}
                        className={classes.dropdown}
                        {...(errors.currency !== "" && {
                          error: true,
                        })}
                        displayEmpty
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return (
                              <em className={classes.placeholder}>
                                Select Tenant Currency
                              </em>
                            );
                          }

                          return getCurrencyById(selected);
                        }}
                      >
                        {optionsCurrency.map((optionsCurrency) => (
                          <MenuItem
                            key={optionsCurrency.currencyId}
                            value={optionsCurrency.currencyId}
                            className={classes.dropdownNew}
                          >
                            {optionsCurrency.currencyName}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.currency !== "" && (
                        <FormHelperText className={classes.requiredText}>
                          This is a required field
                        </FormHelperText>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Box className={classes.setBoxTextFieldsOther}>
                      <FormLabel className={classes.label}>
                        Tenant Data Center{" "}
                        <div style={{ color: "red" }}> *</div>
                      </FormLabel>

                      <Select
                        fullWidth
                        data-testid="selectDatacenterName"
                        labelId="datacenterName"
                        id="datacenterName"
                        value={enteredDatacenter}
                        size="small"
                        type="text"
                        onChange={DataCenterChangeHandler}
                        {...(errors.datacenter !== "" && {
                          error: true,
                        })}
                        className={classes.dropdown}
                        displayEmpty
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return (
                              <em className={classes.placeholder}>
                                Select Tenant Data Center
                              </em>
                            );
                          }

                          return getDataCenterById(selected);
                        }}
                      >
                        {" "}
                        {optionsDataCenter.map((optionsDataCenter) => (
                          <MenuItem
                            className={classes.dropdown}
                            key={optionsDataCenter.datacenterId}
                            value={optionsDataCenter.datacenterId}
                          >
                            {optionsDataCenter.datacenterName}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.datacenter !== "" && (
                        <FormHelperText className={classes.requiredText}>
                          This is a required field
                        </FormHelperText>
                      )}
                    </Box>{" "}
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Box className={classes.setBoxTextFieldsOther}>
                      <FormLabel className={classes.label}>
                        Time Zone <div style={{ color: "red" }}> *</div>
                      </FormLabel>
                      <Tooltip
                        title={
                          isTimeZoneDisabled
                            ? "Please select a region first"
                            : ""
                        }
                      >
                        <Select
                          fullWidth
                          labelId="timezoneName"
                          id="timezoneName"
                          data-testid="selecttimezoneName"
                          value={enteredTimeZone}
                          size="small"
                          type="text"
                          className={classes.dropdown}
                          onChange={TimezoneChangeHandler}
                          {...(errors.timezone !== "" && {
                            error: true,
                          })}
                          displayEmpty
                          input={<OutlinedInput />}
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <em className={classes.placeholder}>
                                  Select Time Zone
                                </em>
                              );
                            }

                            return getTimeZoneById(selected);
                          }}
                        >
                          {TimezoneMapping.map((optionstimeZone) => (
                            <MenuItem
                              key={optionstimeZone.timezoneId}
                              value={optionstimeZone.timezoneId}
                              className={classes.dropdown}
                            >
                              {optionstimeZone.timezoneName}
                            </MenuItem>
                          ))}
                        </Select>
                      </Tooltip>
                    </Box>
                    {errors.timezone !== "" && (
                      <FormHelperText className={classes.requiredText}>
                        This is a required field
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Box className={classes.setBoxTextFieldsOther}>
                      <FormLabel className={classes.label}>
                        Select Product <div style={{ color: "red" }}> *</div>
                      </FormLabel>
                      <Autocomplete
                        data-testid="SelectProduct"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            marginTop: 0.1,
                            lineHeight: 0.9,
                          },
                          // "--Autocomplete-wrapperGap": "30px",
                          "--Chip-minHeight": "3px",
                          "& .MuiAutocomplete-listbox": {
                            padding: 0,
                            paddingTop: 0,
                          },
                          "& .MuiInputBase-input": {
                            height: "1em",
                          },
                          "& .MuiAutocomplete-tag ": {
                            backgroundColor: "#272727",
                            borderRadius: "5px",
                            height: "100%",
                            border: "1px solid #D0D0D0",
                          },
                        }}
                        multiple
                        id="checkboxes-tags-demo"
                        options={optionsProduct}
                        value={enteredProduct}
                        disableCloseOnSelect
                        className={classes.dropdown}
                        getOptionLabel={(option) => option.applicationName}
                        onChange={handleApplicationSelection}
                        renderOption={(
                          props,
                          option: OptionsProduct,
                          { selected }: AutocompleteRenderOptionState
                        ) => {
                          const selectAllProps =
                            option?.applicationId === "selectAll"
                              ? { checked: allSelected }
                              : {};
                          return (
                            !allSelected && (
                              <li
                                {...props}
                                style={{
                                  alignItems: "center",
                                  paddingRight: 2,
                                }}
                                className={classes.dropdown}
                              >
                                <Checkbox
                                  className={classes.dropdown}
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  checked={selected}
                                  {...selectAllProps}
                                />
                                {option.applicationName}
                              </li>
                            )
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              "& .MuiAutocomplete-root .MuiInputBase-input": {
                                height: "1em",
                              },
                            }}
                            placeholder={
                              enteredProduct.length === 0
                                ? "Select Product"
                                : ""
                            }
                            className={classes.dropdown}
                            {...(enteredProductSubmit.length === 0 &&
                              true && {
                                error: true,
                              })}
                            {...params}
                          />
                        )}
                      />
                      {enteredProductSubmit.length === 0 && (
                        <FormHelperText className={classes.requiredText}>
                          This is a required field
                        </FormHelperText>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            width: "98%",
            backgroundColor: "#272727",
            border: "1px solid #101010",
            boxShadow:
              "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
            display: "flex",
            position: "fixed",
            bottom: 1,
            height: "7vh",
          }}
        >
          <Grid sx={{ height: "5vh" }}>
            <Button
              color="primary"
              fullWidth
              data-testid="cancelButtonForDialog"
              sx={{
                fontSize: 12,
                padding: 2,
                height: "10px",
                margin: "1vw",
                position: "relative",
              }}
              className={classes.cancelButton}
              onClick={() => setCancelOpen(true)}
            >
              Cancel
            </Button>
            <Dialog open={cancelOpen} onClose={() => setCancelOpen(false)}>
              <DialogTitle
                sx={{
                  backgroundColor: "#272727",
                  width: "400px",
                  height: "100px",
                }}
                className={classes.dialogHeading}
                id="dialog-title"
              >
                Cancel
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={() => setCancelOpen(false)}
                  aria-label="close"
                  sx={{ marginLeft: "auto" }}
                >
                  <CloseIcon onClick={() => setCancelOpen(false)} />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ backgroundColor: "#272727" }}>
                <DialogContentText
                  sx={{ backgroundColor: "#272727" }}
                  className={classes.dialogInfo}
                >
                  Do you want to cancel the Tenant update?
                </DialogContentText>
              </DialogContent>
              <DialogActions
                sx={{
                  backgroundColor: "#272727",
                  paddingRight: 4,
                  paddingBottom: 4,
                }}
              >
                <Button
                  className={classes.dialogCancelButton}
                  onClick={() => setCancelOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  className={classes.dialogCreateButton}
                  autoFocus
                  onClick={confirmCancelHandller}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            sx={{ height: "5vh", paddingRight: "1.5vw" }}
          >
            <Button
              sx={{
                fontSize: 12,
                padding: 2,
                height: "1vh",
                position: "relative",
                margin: "1vw",
                opacity: !isFormDataChanged ? "0.4" : "1",
              }}
              variant="contained"
              className={classes.createButton}
              onClick={validateData}
              {...(checkIfAnyTextFilled() && { disabled: true })}
              disabled={!isFormDataChanged}
            >
              Update
            </Button>
            <Dialog open={createOpen} onClose={() => setCreateOpen(false)}>
              <DialogTitle
                sx={{
                  backgroundColor: "#272727",
                  width: "400px",
                  height: "100px",
                }}
                className={classes.dialogHeading}
                id="dialog-title"
              >
                Update Tenant
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={() => setCancelOpen(false)}
                  aria-label="close"
                  sx={{ marginLeft: "auto" }}
                >
                  <CloseIcon onClick={() => setCreateOpen(false)} />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ backgroundColor: "#272727" }}>
                <DialogContentText
                  sx={{ backgroundColor: "#272727" }}
                  className={classes.dialogInfo}
                >
                  Do you want to Update this Tenant?
                </DialogContentText>
              </DialogContent>
              <DialogActions
                sx={{
                  backgroundColor: "#272727",
                  paddingRight: 4,
                  paddingBottom: 4,
                }}
              >
                <Button
                  className={classes.dialogCancelButton}
                  onClick={() => setCreateOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  className={classes.dialogCreateButton}
                  onClick={onSubmitHandeller}
                  type="submit"
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
            {isLoading && <Loader />}
          </Grid>
        </Grid>
      </form>
      {openDialogServerError && (
        <DialogForError
          data-testid="DialogForError"
          open={openDialogServerError}
          onClose={onDialogForServerCloseHandler}
          errorList={errorList}
          errorType="serverError"
        />
      )}
      {/* /// Open NoURL error */}
      {openDialogNoURLError && (
        <DialogForError
          open={openDialogNoURLError}
          onClose={onDialogForNOURLCloseHandler}
          errorList={errorList}
          errorType="noURLFoundError"
        />
      )}
      {/* /// Open Toast error */}
      {openToastError && (
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList}
        />
      )}
    </Paper>
  );
}
function checkIfValueCHanged(defaultValue: string, newValue: string) {
  if (defaultValue === newValue) {
    return false;
  } else {
    return true;
  }
}

export default EditTenantPage;
